import { createModuleContext } from '@rebuild/utils/moduleContext';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const MODULE_NAME = 'investment_activity';

function buildBaseCtx() {
	return {};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

const useCurrentReactive = () => {
	const context = useCurrentContext();

	const skipInHK09606 = item => {
		if (item.conferenceStatus === 7 && item.recordSupport !== 1) {
			// 已经结束且没有保留回放，不允许点击进入详情页；
			return true;
		}
		return false;
	};

	const { viewModule } = useModuleNavigation();
	const viewInvestmentActivity = item => {
		if (item.businessTypes === 8 && context.viewInHK09606 && skipInHK09606(item)) {
			return;
		}
		viewModule('investment_activity', item);
	};
	const viewInRoadshow = item => {
		if (context.viewInHK09606 && skipInHK09606(item)) {
			return;
		}
		viewModule('roadshow', item);
	};

	return {
		viewInvestmentActivity,
		viewInRoadshow
	};
};

export { provideCurrentContext, useCurrentContext, useCurrentReactive };
